import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CategoryManager from './CategoryManager';
import randomInt from "../utils/randomInt";

class CategoryStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.CATEGORY_BY_ID_STORE_FETCH:
        CategoryManager.fetchById(action.id);
        return this.getInitialState();

      case ActionTypes.CATEGORY_BY_ID_STORE_FETCH_COMPLETE:
        return action.category;

      default:
        return state;
    }
  }

  getRandomCover(category) {
    if(category['covers'].length===1)
      return category['covers'][0]['cover'];

    return category['covers'][randomInt(0, category.covers.length-1)]['cover'];
  }


}

export default new CategoryStore();
